// import React from 'react'
// import { Link, useLocation } from 'react-router-dom'
// import bicepsSvg from '../../../assets/biceps.svg'
// import { useState } from 'react'
// import logoMenu from '../../../assets/img/logo-colores-originales-sin-bajada.png'
// import { CustomListItem } from './listComponent/CustomListItem'
// import logger from '../../../../src/utils/logger';

// export const SideMain = () => {

//     const menuOption = JSON.parse(localStorage.getItem('menuOption'));
//     logger.debug('menuOption: ', menuOption)


//     // const customMenuOption = menuOption.push({
//     //     icon: "assignment",
//     //     id: 9,
//     //     title: "Formaciones",
//     //     url: "FormationsDetail",
//     // })

//     const [clickedBtn, setClickedBtn] = useState(1)

//     const location = useLocation()

//     logger.debug('location sideMain: ', location)
//     // logger.debug('location SIDEMENU is: ', location.pathname.replace(/^\/+/, ""))


//     const defaultSelected = menuOption.find((path) => { return path.url === location.pathname.replace(/^\/+/, "") })
//     logger.debug('defaultSelected: ', defaultSelected)


//     const functionBtn = (e) => {
//         const selectedBtn = Number(e.currentTarget.dataset.id)

//         setClickedBtn(selectedBtn)
//         logger.info('clickedBtn: ', clickedBtn)
//     }


//     return (
//         <div className="col-md-2 d-none d-md-flex menu">


//             <img className="menu-logo" src={logoMenu} alt="logo" />
//             <hr className="hr-menu" />
//             <ul className="menu-list">

//                 {menuOption && menuOption.length > 0 ? menuOption.map((i) => {
//                     return (
//                         <CustomListItem
//                             key={i.id}
//                             clickedBtn={clickedBtn}
//                             functionBtn={functionBtn}
//                             index={i.id}
//                             icon={i.icon}
//                             title={i.title}
//                             url={i.url}
//                             defaultSelected={!defaultSelected && i.url === "Members" ? true : false}
//                         />
//                     )

//                 })
//                     : null}

            
//             </ul>

//         </div>
//     )
// }


// import React, { useState } from 'react'
// import { useLocation } from 'react-router-dom'
// import logoMenu from '../../../assets/img/logo-colores-originales-sin-bajada.png'
// import { CustomListItem } from './listComponent/CustomListItem'
// import logger from '../../../../src/utils/logger'

// export const SideMain = () => {

//     const menuOption = JSON.parse(localStorage.getItem('menuOption'))
//     const [clickedBtn, setClickedBtn] = useState(1)

//     const location = useLocation()
//     logger.debug('location sideMain: ', location.pathname)

//     const functionBtn = (e) => {
//         const selectedBtn = Number(e.currentTarget.dataset.id)
//         setClickedBtn(selectedBtn)
//     }

//     return (
//         <div className="col-md-2 d-none d-md-flex menu">

//             <img className="menu-logo" src={logoMenu} alt="logo" />
//             <hr className="hr-menu" />

//             <ul className="menu-list">
//                 {menuOption && menuOption.length > 0 &&
//                     menuOption.map((i) => (
//                         <CustomListItem
//                             key={i.id}
//                             index={i.id}
//                             icon={i.icon}
//                             title={i.title}
//                             url={i.url}
//                             functionBtn={functionBtn}
//                         />
//                     ))
//                 }
//             </ul>
//         </div>
//     )
// }

import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import logoMenu from '../../../assets/img/logo-colores-originales-sin-bajada.png'
import { CustomListItem } from './listComponent/CustomListItem'

export const SideMain = () => {

    const menuOption = JSON.parse(localStorage.getItem('menuOption'))
    const [clickedBtn, setClickedBtn] = useState(1)
    const location = useLocation()

    // 🔹 rutas hijas → menú padre
    const ROUTE_PARENT_MAP = {
        FormationsDetail: 'Formations',
        FormationInfo: 'Formations',
    }

    const pathname = location.pathname.replace(/^\/+/, '')
    const basePath = pathname.split('/')[0]

    const resolvedMenu =
        ROUTE_PARENT_MAP[basePath] || basePath

    const menuUrls = menuOption.map(item => item.url)

    // 🔥 menú activo REAL (una sola verdad)
    const activeMenu = menuUrls.includes(resolvedMenu)
        ? resolvedMenu
        : 'Members'

    const functionBtn = (e) => {
        const selectedBtn = Number(e.currentTarget.dataset.id)
        setClickedBtn(selectedBtn)
    }

    return (
        <div className="col-md-1 col-lg-2 d-none d-md-flex menu">

            <img className="menu-logo" src={logoMenu} alt="logo" />
            <hr className="hr-menu" />

            <ul className="menu-list">
                {menuOption.map((i) => (
                    <CustomListItem
                        key={i.id}
                        index={i.id}
                        icon={i.icon}
                        title={i.title}
                        url={i.url}
                        functionBtn={functionBtn}
                        isActive={i.url === activeMenu}
                    />
                ))}
            </ul>
        </div>
    )
}
